import { createAsyncThunk } from "@reduxjs/toolkit";
import { post } from "helpers/api_helper";
import {
  CANCEL_ORDER,
  GENERATE_ORDER_INVOICE,
  GET_ALL_ORDERS,
  GET_ORDER_details,
} from "helpers/url_helper";

export const getAllOrders = createAsyncThunk(
  GET_ALL_ORDERS,
  async (payload) => {
    const response = await post(GET_ALL_ORDERS, payload);
    return response;
  }
);

export const getOrderDetails = createAsyncThunk(
  GET_ORDER_details,
  async (payload) => {
    const response = await post(GET_ORDER_details, payload);
    return response;
  }
);

export const cancelOrder = createAsyncThunk(CANCEL_ORDER, async (payload) => {
  const response = await post(CANCEL_ORDER, payload);
  return response;
});

export const generateOrderInvoice = createAsyncThunk(
  GENERATE_ORDER_INVOICE,
  async (payload) => {
    const response = await post(GENERATE_ORDER_INVOICE, payload);
    return response;
  }
);
